import { View, Text, Image, TouchableOpacity } from "react-native";
import React, { useEffect } from "react";
import * as Animatable from "react-native-animatable";
import StaticImages from "../../../assets/StaticImages";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";
import { LinearGradient } from "expo-linear-gradient";
import ModalComponent from "../../ModalComponent";
import FeedIcons from "../../../assets/Icons/FeedIcons";
import styles from "./stylesActionModal/matchModalStyles";

export default function MatchModal({
  isVisible,
  toggleModal,
}: {
  isVisible: boolean;
  toggleModal: any;
}) {
  useEffect(() => {
    // You can trigger the animation when the component mounts
    fadeInFromBottom();
  }, []);
  const textRef = React.createRef<Animatable.View>();
  const fadeInFromBottom = () => {
    // Check if textRef and textRef.current are defined
    if (textRef?.current) {
      // Check if fadeInUp is defined before calling it
      const fadeInUp = textRef.current.fadeInUp;
      if (fadeInUp) {
        fadeInUp(700);
      }
    }
  };

  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View style={styles.Container}>
        <View style={styles.MatchContainerWrap}>
          <TouchableOpacity
            onPress={() => {
              toggleModal();
            }}
            style={styles.close}
          >
            <FeedIcons.WhiteClose />
          </TouchableOpacity>
          <View style={styles.MatchContainer}>
            <Image
              source={StaticImages.Display2}
              style={styles.MatchContainerImg}
            />
            <View style={styles.Star}>
              <FeedIcons.Star />
            </View>
            <Image
              source={StaticImages.Display}
              style={styles.MatchContainerImg}
            />
          </View>
          <LinearGradient
            colors={["rgba(0,0,0,0.6)", "transparent"]} //
            style={{
              position: "absolute",
              width: "100%",
              top: 0,
              right: 0,
              height: 240,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          />
          <LinearGradient
            colors={["transparent", Colors.darkGreen]} //
            style={{
              position: "absolute",
              width: "100%",
              bottom: 0,
              height: 240,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          />
          {/* <View style={styles.Grad}>
          <Icons.GreenGrad />
        </View> */}
        </View>
        <Animatable.View
          ref={textRef}
          animation="fadeInUp"
          duration={700}
          delay={0}
          easing="ease-in-back"
        >
          <Text
            style={[
              GlobalStyles.heading1,
              {
                color: "#FDFBF9",
                textAlign: "center",
                position: "relative",
                top: -30,
              },
            ]}
          >
            It's a match
          </Text>
        </Animatable.View>
        <Text
          style={[
            GlobalStyles.bodyText,
            {
              textAlign: "center",
              color: "#FDFBF9",
              marginTop: 20,
            },
          ]}
        >
          Now it’s time to play your move
        </Text>
        <View style={styles.Button}>
          <FeedIcons.FrontArrow />
        </View>
      </View>
    </ModalComponent>
  );
}
